<template>
  <div id="case-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden body-module-height z-20">
    <template v-if="renderFilter">
      <vs-sidebar class="items-no-padding case-filter" parent="#case-app" :click-not-close="clickNotClose"
                  :hidden-background="clickNotClose" v-model="isCaseFilterSidebarActive">
        <case-filter @closeSidebar="toggleCaseSidebar" />
      </vs-sidebar>
    </template>

    <div :class="{'sidebar-spacer': clickNotClose}"
         class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

      <!-- SEARCH BAR -->
      <div class="flex border d-theme-dark-bg items-center">
        <template v-if="renderFilter">
          <feather-icon class="inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleCaseSidebar(true)"/>
        </template>
        <vs-input icon-no-border icon="icon-search" size="normal" icon-pack="feather" placeholder="Search Case" v-model="searchQuery"
                  class="vs-input-no-border vs-input-no-shdow-focus w-full" />
      </div>

      <!-- Case LIST -->
      <component :is="scrollbarTag" class="content-scroll-area list-cases" :settings="settings" ref="mailListPS" :key="$vs.rtl" style="-webkit-transform: translate3d(0, 0, 0)">
        <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
<!--      :style="{transitionDelay: (index * 0.1) + 's'}"    -->
          <li class="cursor-pointer email__mail-item" v-for="(caseItem) in cases" :key="caseItem.id">
            <case-preview :current-case="caseItem" @markReviewSolved="markAsSolved" @openCase="openCase" @archiveCase="archiveCase"/>
          </li>
        </transition-group>
      </component>
    </div>

    <!-- CASE VIEW SIDEBAR -->
    <case-view
      parent-div="case-app"
      :case-id="openCaseId"
      :is-case-sidebar-active="isCaseSidebarActive"
      margin-sidebar="case-sidebar"

      @closeSidebar="closeCaseViewSidebar"
      @archiveCase="archiveCase">
    </case-view>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CaseFilter from './cases/CaseFilter.vue'
import CasePreview from './cases/CasePreview.vue'
import CaseView from './cases/CaseView.vue'

import {CASE_STATUS_REVISING} from '@/models/Case.model';

import CaseService from '@/services/Case.service'
import {setTimeoutAsync, showErrorNotify, showSuccessNotify} from "@/helpers/functionsHelpers";

export default {
  components: {
    CaseFilter,
    CasePreview,
    CaseView,
    VuePerfectScrollbar
  },
  props: {
    renderFilter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isCaseSidebarActive: false,
      openCaseId: 0, //Using openCaseId as a :key to force mounted to be called each time it changes.
      current_filter: null,

      clickNotClose: true, //For mobile, filter is closable in mobile
      isCaseFilterSidebarActive: true,

      // cases: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30
      }
    }
  },
  watch: {
    caseFilter() {
      if (isNaN(this.$route.params.filter)) {
        this.filterCasesFromStore();
      } else {
        this.openCase(Number(this.$route.params.filter));
      }
    },
    openCaseId() {
      console.debug('CASE = ', this.openCaseId);
    },
    windowWidth() {
      this.setSidebarWidth();
    },
  },
  computed: {
    caseFilter() { //To force update when sidebar filter is clicked
      return this.$route.params.filter;
    },
    searchQuery: {
      get() {
        return this.$store.state.Case.getTimeUpdate();
      },
      set(val) {
        this.$store.dispatch('Case/setCaseSearchQuery', val);
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    cases() {
      if (this.$route.params.filter === CASE_STATUS_REVISING) {
        return this.$store.state.Case.revisionCases();
      } else {
        return this.$store.state.Case.caseFilterActive(this.$route.params.filter);
      }
    }
  },
  methods: {
    filterCasesFromStore() {
      if (isNaN(this.$route.params.filter)) { //If is a case filter, should close any opened case
        this.toggleCaseSidebar();
        this.current_filter = this.$route.params.filter;
      }

      const scroll_el = this.$refs.mailListPS.$el || this.$refs.mailListPS;
      scroll_el.scrollTop = 0;
    },
    openCase(caseId) {
      if (caseId) {
        this.openCaseId = caseId;
        this.isCaseSidebarActive = true;
      }
    },
    markAsSolved(review_id) {
      CaseService.markCaseSolved(review_id).then((response) => {
        this.$store.dispatch('Case/setCase', response).then(() => {
          showSuccessNotify(this, this.$t('pages.cases.markAsSolved'));
        });
      }, error => {
        showErrorNotify(this, error);
      });
    },
    closeCaseSidebar() {
      this.isCaseSidebarActive = false;
      this.openCaseId = 0;
    },
    closeCaseViewSidebar() {
      if (this.current_filter) {
        this.$router.push(`/cases/${this.current_filter}`);
      } else {
        this.$router.push(`/cases/new`); //default route if come through link
      }
    },
    archiveCase(caseId) {
      CaseService.archiveCase(caseId).then((response) => {
        this.$nextTick(() => {
          this.$store.dispatch('Case/setCase', response).then(() => {
            showSuccessNotify(this, this.$t('pages.cases.caseView.messages.archiveSuccessfully'));
            this.closeCaseSidebar();
            this.closeCaseViewSidebar();
          });
        });
      }, error => {
        showErrorNotify(this, error);
      });
    },
    setSidebarWidth() {
      if (this.windowWidth < this.$store.state.responsiveBreakPoints.lg) {
        this.isCaseFilterSidebarActive = this.clickNotClose = false;
      } else {
        this.isCaseFilterSidebarActive = this.clickNotClose = true;
      }
    },
    toggleCaseSidebar(value = false) {
      if (!value) {
        this.closeCaseSidebar();
        if (this.clickNotClose) {
          return;
        }
      }
      this.isCaseFilterSidebarActive = value;
    },
    getCases() {
      const filter = this.$route.params.filter || '';
      return CaseService.listCases(filter).then((response) => {
        return this.$store.dispatch('Case/setCases', response).then(() => {
          return Promise.resolve(true);
        });
      }, error => {
        showErrorNotify(this, error);
        return Promise.reject(error);
      });
    },

    getCaseNotification() {
      if (!process.env.VUE_APP_NOTIFICATIONS_ENABLE) {
        return Promise.resolve(false);
      }

      const openedCaseId = this.openCaseId;
      const func_cb = () => {
        if (openedCaseId) {
          return this.$store.dispatch('Notifications/fetchStatusCaseNotification', openedCaseId);
        }

        return this.getCaseNotification();
      }

      return setTimeoutAsync(func_cb, process.env.VUE_APP_NOTIFICATION_POOLING_CASE * 1000);
    }
  },
  created() {
    this.setSidebarWidth();
  },
  mounted() {
    this.$store.dispatch('Case/setCaseSearchQuery', '');
    this.getCaseNotification();

    const case_id = this.$route.params.filter || 0;
    if (case_id) {
      this.openCase(Number(case_id));
    }

    this.getCases().then(() => {
      return this.filterCasesFromStore();
    });
    this.loaded = true;
  }
}
</script>

<style lang="scss">
  @import 'src/assets/scss/cases.scss';
.email__mails {
  .email__mail-item {
    transition: all .35s;

    &:not(:first-of-type) {
      .mail__mail-item {
        border-top: 1px solid #dae1e7;
      }
    }

    .mail__mail-item {
      transition: all 0.2s;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0px 3px 10px 0px #ccc;
        transition: all 0.2s;
      }

      // Star icon color
      .feather-icon {
        color: #9c9c9c;
      }
    }
  }
}

  .content-scroll-area.list-cases {
    height: calc(100%);
  }
</style>
